import { Box, Flex } from "@chakra-ui/react";
import { ArrayFieldTemplateProps } from "@rjsf/utils";

import { TabButton } from "@/components/tab-button";

import { useTemplateArrayField } from "../hooks/use-template-array-field";

export const CustomArrayFieldTemplate = (props: ArrayFieldTemplateProps) => {
  const { items, canAdd, title, schema, registry } = props;
  const { AddButton, RemoveButton } = registry.templates.ButtonTemplates;

  const label = title || schema.title || "Item";
  const minItems = schema.minItems ?? 0;

  const { activeIndex, setActiveIndex, handleAddClick, getItemLabel, handleRemoveItem } =
    useTemplateArrayField(props);

  return (
    <Flex maxW="full" minW="fit-content" flexDir="column">
      <Flex>
        {/* No items */}
        {items.length === 0 && <TabButton handleClick={handleAddClick}>Geen {label}</TabButton>}

        {/* Tabs for each item */}
        {items.map((item, index) => (
          <TabButton
            key={item.key}
            active={activeIndex === index}
            handleClick={() => {
              setActiveIndex(index);
            }}
          >
            <Flex w="full" overflow="hidden" whiteSpace="nowrap" textOverflow="ellipsis">
              {items.length < 6 ? label : undefined} {getItemLabel(item)}
            </Flex>

            {/* Close button */}
            {item.hasRemove && items.length > minItems && (
              <Flex
                position="absolute"
                right={2}
                top="50%"
                transform="translateY(-50%)"
                onClick={(e) => {
                  e.stopPropagation();
                  handleRemoveItem(index);
                }}
              >
                <RemoveButton disabled={item.disabled} registry={registry} />
              </Flex>
            )}
          </TabButton>
        ))}

        {/* Add button */}
        {canAdd && items.length > 0 && (
          <Box ml="auto">
            <TabButton isAddTab handleClick={handleAddClick}>
              <AddButton disabled={!canAdd} onClick={handleAddClick} registry={registry} />
            </TabButton>
          </Box>
        )}
      </Flex>

      {/* Tab content */}
      {items.length > 0 && (
        <Flex
          p={5}
          pb={0}
          w="full"
          border="1px solid"
          borderColor="accent"
          borderTop="0px"
          borderTopRightRadius="0px !important"
          borderTopLeftRadius={activeIndex === 0 ? "0px !important" : undefined}
          borderRadius="xl"
        >
          {items.map((item, index) => (
            <Flex
              key={item.key}
              w="full"
              display={activeIndex === index ? "flex" : "none"}
              flexDirection="column"
            >
              {item.children}
            </Flex>
          ))}
        </Flex>
      )}
    </Flex>
  );
};
